<template>
	<div class="classnote_wrap">
		<div class="classnoteList">
      <ul>
        <li v-for="(item,index) in list" :key="item.id" :class="{active:num==index}" @click="getNum(index)">
          {{item}}
        </li>
        <span class="line"></span>
      </ul>
    </div>
    <div class="classnoteTabCon" v-if="classNoteData.length" v-loading="loading">
      <div class="classnote-list" :style="{height:styleHeight}">
        <div class="note-list-item" v-for="(item,index) in classNoteData" :key="index">
        	<div class="left_portrait">
        		<img src="../../../../../../static/images/study/icon/teacher.png"/>
        	</div>
        	<div class="right_portrait">
        		<div class="top">
	        		<span class="name">{{item.username}}</span>
	        		<span class="time">{{item.date}}</span>
	        		<span class="status" :style="handleStatus(item.noteType)">{{item.noteType}}</span>
	        	</div>
	        	<div class="content">
	        		<span class="m-content overflow-line">{{item.content}}</span>
	        		<el-button type="text" class="btn-more" v-if="item.content.length>124?isShowMore=true:isShowMore=false" id="J_btnmore" @click="showmoreDesc($event)">展开</el-button>
	        	</div>
	        	<div class="bottom">
	        		<div class="left">
	        			<img src="../../../../../../static/images/study/icon/zhangjie.png"/>
	        			<span v-if="item.catalogName">{{item.catalogName}}</span>
	        			<span v-else>全部章节</span>
	        		</div>
	        		<ul class="right">
	        			<li class="dianzan" v-if="!item.isUserPraise" @click="assist(item.noteId)">
	        				<div></div>
	        				<span>{{item.notePraiseNumber}}</span>
	        			</li>
	        			<li class="y_dianzan" v-else @click="unassist(item.noteId)">
	        				<div></div>
	        				<span>{{item.notePraiseNumber}}</span>
	        			</li>
	        			<li class="pinglun" @click="getComments(item)">
	        				<div></div>
	        				<span>{{item.replyNumber}}</span>
	        				<div class="comment1" v-if="item.status == 1"></div>
	        				<div class="comment3" v-if="item.status == 1"></div>
	        			</li>
	        			<li class="note_editor" @click="editorNote(item)" v-if="item.isOwn">
	        				<div></div>
	        			</li>
	        			<li class="delete" @click="delNote(item.noteId)" v-if="item.isOwn || item.isTeacher">
	        				<div></div>
	        			</li>
	        		</ul>
	        	</div>
	        	<div class="commentConts" v-if="item.status == 1" v-loading="noteLoading">
	        		<div class="comment2">
	        			<div class="comment2_cont">
	        				<div class="pinglun_text">
		        				<el-input type="textarea" resize="none" placeholder="请输入内容" v-model="discussionContent" maxlength="300" show-word-limit οnkeyup="this.value=this.value.replace(/\s+/g,'')"></el-input>
		        				<div class="btn">
		        					<el-button type="primary" :disabled="disabledBtn" @click="publish(item)">发表</el-button>
		        				</div>
		        			</div>
		        			<el-divider v-if="commentList.length"></el-divider>
		        			<div class="comment-item" v-for="(key,index) in commentList" :key="index">
		        				<div class="commentContent">
		        					{{key.replyContent}}
		        				</div>
		        				<div class="comment-bottom">
		        					<div class="left">
		        						<span>{{key.userName}}<i class="zhiwei" v-if="key.isTeacherReply">教师</i></span>
		        						<span>{{key.date}}</span>
		        					</div>
		        					<div class="right" v-if="key.isDelete || item.isTeacher" @click="delComment(key.replyId,key.learnId)"></div>
		        				</div>
		        			</div>
	        			</div>
	        		</div>
	        	</div>
        	</div>
        </div>
      </div>
    </div>
    <div class="noData" v-else>
      <img src="../../../../../../static/images/wujieguo.png"/>
      <p>暂无相关内容</p>
    </div>
	</div>
</template>

<script>
	import * as api from "../../../../../api/noteApi";
	export default {
    name: "classNote",
    components: {
    },
    data(){
      return{
        list:["最新发表", "点赞数"],
        num:0,
        tabContents:[{
        	name:1
        },{
        	name:2
        }],
        options: [{
          value: '全部',
          label: '全部'
        }, {
          value: '已公开',
          label: '已公开'
        }, {
          value: '未公开',
          label: '未公开'
        }],
        value: '全部',
        classNoteData:[],
        pageTotal:{
          page: 1,
          pageSize: 10,
          total: 0,
          currentPage:1
        },
        catalogItem:{},
        styleHeight:window.innerHeight - 249 + "px",
        loading:true,
        isShowMore:false,
        isDescStatus:true,
        introduce:'',
        commentList:[],
        noteLoading:false,
        discussionContent:'',
        disabledBtn:true,
        userType:sessionStorage.getItem('userType')
      }
    },
    created(){

    },
    watch:{
    	discussionContent(val){
    		val ? this.disabledBtn = false : this.disabledBtn = true;
    	}
    },
    methods: {
      getNum(index) {
        this.num = index;
        this.loading = true;
        this.pageTotal.page = 1;
        this.getClassNote(this.catalogItem);
      },
      // 获取我的笔记数据
      getClassNote(data){
      	let isRecently,isPraise;
      	this.num == 0?isRecently=true:isRecently=false;
      	this.num == 0?isPraise=false:isPraise=true;
      	let param = {};
      	if(data.id == ''){
      		param = {
	      		status:this.value, //状态（全部，已公开，未公开）
	      		isRecently:isRecently, //最新发表true
	      		isPraise:isPraise, //点赞数true
	      		classId:this.$route.query.classId, //班级id
	      		catalogId:'', //目录id
	      		catalogName:'', //目录名称
	      		courseId:this.$route.query.id,
	      		pageNum:this.pageTotal.page,
	      		pageSize:this.pageTotal.pageSize
	      	}
      	}else{
      		param = {
	      		status:this.value, //状态（全部，已公开，未公开）
	      		isRecently:isRecently, //最新发表true
	      		isPraise:isPraise, //点赞数true
	      		classId:this.$route.query.classId, //班级id
	      		catalogId:data.id, //目录id
	      		catalogName:data.catalogName, //目录名称
	      		courseId:this.$route.query.id,
	      		pageNum:this.pageTotal.page,
	      		pageSize:this.pageTotal.pageSize
	      	}
      	}
      	this.catalogItem = data;
      	api.getClassNote(param).then(res=>{
      		if(res.code == 0){
      			this.loading = false;
      			let arr = [];
      			let list = res.data.list;
      			for(var i=0; i<list.length; i++){
      				let obj = {};
      				obj.status = 0;
      				obj.catalogId = list[i].catalogId;
							obj.catalogName = list[i].catalogName;
							obj.content = list[i].content;
							obj.date = list[i].date;
							obj.isOwn = list[i].isOwn;
							obj.isTeacher = list[i].isTeacher;
							obj.isUserPraise = list[i].isUserPraise;
							obj.noteId = list[i].noteId;
							obj.notePraiseNumber = list[i].notePraiseNumber;
							obj.noteType = list[i].noteType;
							obj.replyNumber = list[i].replyNumber;
							obj.userId = list[i].userId;
							obj.username = list[i].username;
      				arr.push(obj);
      			}
      			this.classNoteData = arr;
      			this.pageTotal.total = res.data.total;
      		}else if(res.code == 6){
      			this.$messageError(res.data.msg);
      		}
      	}).catch(error=>{
      		console.log(error)
      	})
      },
      // 状态切换
      selectChange(val){
      	this.loading = true;
      	this.getClassNote(this.catalogItem)
      },
      currentPageFn(val){
        this.loading = true;
        this.pageTotal.page = val;
        this.getClassNote(this.catalogItem)
        this.pageTotal.currentPage = val;
      },
      // 展开
      showmoreDesc(e) {
        let el = e.currentTarget;
        el.previousElementSibling.classList[!this.isDescStatus ? 'add' : 'remove']('overflow-line');
        el.classList[this.isDescStatus ? 'add' : 'remove']('more-collapse');
        el.innerHTML = !this.isDescStatus ? '展开' : '收起';
        this.isDescStatus = !this.isDescStatus;
        this.isShowMore = true;
      },
      // 处理状态颜色
      handleStatus(type){
      	let styleColor = {};
      	switch (type) {
      		case '已公开':
	      		styleColor = {
	      			border:'1px solid rgba(83,151,247,1)',
	        		color: '#5397F7'
	      		}
      		break;
      		case '未公开':
	      		styleColor = {
	      			border:'1px solid rgba(255,178,60,1)',
	        		color: '#FFB23C'
	      		}
      		break;
      	}
      	return styleColor
      },
      // 删除笔记
      delNote(id){
      	this.$tipsDialog(
      		"提示",
      		"确定删除该笔记吗？",
			    "确定后将删除该笔记下的全部评论",
			    "el-icon-warning",
			    "rgb(255, 178, 60)"
      	).then(() => {
      		api.delNote(id).then(res=>{
	      		console.log(res);
	      		if(res.code == 0){
	      			this.$messageSuccess('删除成功');
	      			this.getClassNote(this.catalogItem);
	      		}
	      	}).catch(error=>{
	      		console.log(error);
	      	})
        }).catch(() => {
//        this.$message({
//          type: 'info',
//          message: '已取消删除'
//        });
        });

      },
      // 编辑笔记
      editorNote(param){
      	this.$store.state.noteObj = param;
      	this.$emit('editorNoteOpen',true);
      },
      // 笔记点赞
      assist(id){
      	let param = {
      		learnId:id,
      		isAdd:true
      	}
      	api.likeIfNote(param).then(res=>{
      		console.log(res);
      		if(res.code == 0){
      			this.getClassNote(this.catalogItem);
      		}
      	}).catch(error=>{
      		console.log(error);
      	})
      },
      // 取消点赞
      unassist(id){
      	let param = {
      		learnId:id,
      		isAdd:false
      	}
      	api.likeIfNote(param).then(res=>{
      		console.log(res);
      		if(res.code == 0){
      			this.getClassNote(this.catalogItem);
      		}
      	}).catch(error=>{
      		console.log(error);
      	})
      },
      // 点击评论获取信息
      getComments(obj){
      	console.log(obj);
      	this.discussionContent = '';
      	if(obj.status == 0){
      		this.$set(obj,'status',1);
      		this.noteLoading = true;
      		this.getNoteReply(obj.noteId,obj.replyNumber);
      	}else{
      		this.$set(obj,'status',0);
      	}
      },
      // 获取笔记评论
      getNoteReply(id,num){
      	api.getNoteReply(id).then(res=>{
      		console.log(res);
      		if(res.code == 0){
      			this.noteLoading = false;
      			let list = res.data;
      			let arr = [];
      			if(list.length){
      				list.forEach(item=>{
      					let obj = {};
      					obj.replyId = item.replyId;
      					obj.learnId = id;
      					obj.userName = item.userName;
      					obj.date = item.date;
      					obj.replyContent = item.replyContent;
      					obj.isDelete = item.isDelete;
      					obj.isTeacherReply = item.isTeacherReply;
      					obj.num = num;
      					arr.push(obj);
      				})
      			}
      			this.commentList = arr;
      		}
      	}).catch(error=>{
      		console.log(error);
      	})
      },
      // 发表评论
      publish(param){
      	if(!this.isNull(this.discussionContent)){
      		let obj = {
	      		learnId:param.noteId,
	      		discussionContent:this.discussionContent,
	      		courseId:this.$route.query.id,
	      		classId:this.$route.query.classId
	      	}
      		api.publishReply(obj).then(res=>{
	      		console.log(res);
	      		if(res.code == 0){
	      			this.noteLoading = true;
	      			this.getNoteReply(obj.learnId);
	      			this.$set(param,'replyNumber',param.replyNumber*1+1);
	      			this.discussionContent = '';
	      		}
	      	}).catch(error=>{
	      		console.log(error);
	      	})
      	}else{
      		this.$messageWarning('评论内容不能全为空或空格');
      		return
      	}
      },
      isNull(str){
		    if (str == "") return true;
		    var regu = "^[ ]+$";
		    var re = new RegExp(regu);
		    return re.test(str);
			},
      // 删除评论
      delComment(id,learnId){
      	this.$tipsDialog(
      		"提示",
      		"确定删除该评论吗？",
			    "",
			    "el-icon-warning",
			    "rgb(255, 178, 60)"
      	).then(() => {
      		api.delReply(learnId,id).then(res=>{
	      		if(res.code == 0){
	      			this.$messageSuccess('删除成功');
	      			this.noteLoading = true;
	      			this.getNoteReply(learnId);
	      		}
	      	}).catch(error=>{
	      		console.log(res);
	      	})
        }).catch(() => {
//        this.$message({
//          type: 'info',
//          message: '已取消删除'
//        });
        });
      }
    }
  }
</script>

<style scoped lang="scss">
	.classnote_wrap {
		.classnoteList {
			margin-bottom: 10px;
			ul {
				overflow: hidden;
				position: relative;
				.line {
					position: absolute;
					width:0px;
					height:12px;
					border:1px solid rgba(230,230,230,1);
					top: 6px;
    			left: 102px;
				}
				li {
					float: left;
					cursor: pointer;
					color: #999999;
					margin-right: 26px;
					font-size: 14px;
					padding: 5px 17px;
				}
				li.active {
					padding: 5px 17px;
					background: #5397F7;
					color: #FFFFFF;
					border-radius: 16px;
				}
			}
		}
		.classnoteTabCon {
			clear: both;
			.classnote-list {
				overflow: auto;
			}
			.note-list-item {
				display: flex;
				justify-content: flex-start;
				min-height: 106px;
				border:1px solid rgba(230,230,230,1);
				border-radius:4px;
				padding: 16px 24px;
				margin-bottom:16px;
				.left_portrait {
					width: 40px;
					height: 100%;
					img {
						display: inline-block;
						width: 40px;
						height: 40px;
					}
				}
				.right_portrait {
					flex: 1;
					.top {
						height: 40px;
						line-height: 40px;
						margin-left: 10px;
						.name {
							font-size: 14px;
						}
						.time {
							color: #999999;
							font-size: 12px;
							padding: 0 40px;
						}
						.status {
							display: inline-block;
							width:48px;
							height:18px;
							line-height: 18px;
							text-align: center;
							opacity:1;
							border-radius:2px;
							font-size: 12px;
						}
					}
					.content {
						margin-left: 10px;
						font-size: 14px;
						min-height: 40px;
						padding: 10px 0;
						position: relative;
						width: 95%;
						.m-content {
							line-height: 20px;
							word-break: break-all;
					    &.overflow-line {
					      display: -webkit-box;
					      -webkit-box-orient: vertical;
					      -webkit-line-clamp: 2;
					      overflow: hidden;
					      float: left;
					      word-break: break-all;
								word-wrap: break-word;
	    					// white-space: pre-wrap;
					    }
					  }
					  .more-collapse {
					  	position: initial !important;
					  }
					  .btn-more {
					  	position: absolute;
					  	top: 32px;
					  }
					  .el-button--text {
					  	padding: 0;
					  }
					}
					.bottom {
						margin-left: 10px;
						display: flex;
						justify-content: space-between;
						img {
							display: inline-block;
							width: 14px;
							height: 14px;
						}
						span {
							font-size: 12px;
							color: #999999;
						}
						.left {
							display: flex;
							justify-content: space-between;
							align-items: center;
							span {
								display: inline-block;
								padding: 0 4px;
							}
						}
						.right {
							float: right;
							li {
								float: left;
								display: flex;
								align-items: center;
								justify-content: space-between;
								padding: 0 20px;
								height: 14px;
								border-right: 1px solid #E6E6E6;
								cursor: pointer;
								div {
									width: 14px;
									height: 14px;
								}
							}
							li:last-child {
								border: 0;
							}
							.dianzan {
								div {
									background: url(../../../../../../static/images/study/icon/dianzan_hv.png) no-repeat;
									background-size: cover;
									margin-right: 6px;
								}
								&:hover {
									div {
										background: url(../../../../../../static/images/study/icon/dianzan.png) no-repeat;
										background-size: cover;
										margin-right: 6px;
									}
								}
							}
							.y_dianzan {
								div {
									background: url(../../../../../../static/images/study/icon/dianzan.png) no-repeat;
									background-size: cover;
									margin-right: 6px;
								}
							}
							.pinglun {
								position: relative;
								div {
									background: url(../../../../../../static/images/study/icon/pinglun_hv.png) no-repeat;
									background-size: cover;
									margin-right: 6px;
								}
								&:hover {
									div {
										background: url(../../../../../../static/images/study/icon/pinglun.png) no-repeat;
										background-size: cover;
										margin-right: 6px;
									}
								}
								.comment1 {
									width: 0px;
		  						height:0px;
		  						border: 8px transparent solid;
		  						border-bottom-color: rgba(230,230,230,1);
		        			margin-left: 472px;
		        			position: absolute;
							    top: 8px;
							    right: 20px;
								}
								.comment3 {
									width: 0px;
		    					height:0px;
		    					border: 9px transparent solid;
		    					border-bottom-color: rgba(244,244,244,1);
		    					position: absolute;
					        top: 8px;
    							right: 19px;
								}
							}
							.note_editor {
								div {
									background: url(../../../../../../static/images/study/icon/bianji_hv.png) no-repeat;
									background-size: cover;
								}
								&:hover {
									div {
										background: url(../../../../../../static/images/study/icon/bianji.png) no-repeat;
										background-size: cover;
									}
								}
							}
							.delete {
								div {
									background: url(../../../../../../static/images/study/icon/shanchu_hv.png) no-repeat;
									background-size: cover;
								}
								&:hover {
									div {
										background: url(../../../../../../static/images/study/icon/shanchu.png) no-repeat;
										background-size: cover;
									}
								}
							}
						}
					}
					.commentConts {
						.comment2 {
			        background: rgba(244,244,244,1);
			       	border: 1px rgba(230,230,230,1) solid;
              /*min-height: 105px;*/
              /*max-height: 396px;*/
              height: 396px;
        			border-radius: 4px;
        			margin-top: 10px;
        			padding: 16px;
        			overflow: auto;
        			.noComment {
					      text-align: center;
					      img{
					        width: 100px;
					        margin-top: 20px;
					      }
					      p{
					        font-size:14px;
					        font-weight:400;
					        color:rgba(153,153,153,1);
					        margin-top: 16px;
					      }
							}
        			.pinglun_text {
        				/deep/ .el-textarea__inner {
        					height: 64px;
        				}
        				.el-button--primary.is-disabled {
        					background-color: #E6E6E6;
        					border-color: #E6E6E6;
        					color: #999999;
        				}
        				.el-button {
        					padding: 8px 23px;
        					font-size: 12px;
        				}
        				.btn {
        					margin-top: 12px;
        					text-align: right;
        				}
        			}
        			.el-divider--horizontal {
        				margin: 16px 0;
        			}
        			.comment-item {
        				padding-bottom: 16px;
        				border-bottom: 1px solid #DCDFE6;
        				.commentContent {
        					padding: 14px 0;
        				}
        				.comment-bottom {
        					display: flex;
        					justify-content: space-between;
        					align-items: center;
        					.left {
        						min-width: 200px;
        						display: flex;
        						justify-content: space-between;
        						align-items: center;
        						span {
        							color: #999999;
        						}
        						.zhiwei {
        							display: inline-block;
        							width:34px;
											height:18px;
											text-align: center;
											line-height: 18px;
											background:rgba(232,242,255,1);
											opacity:1;
											border-radius:2px;
											font-size: 12px;
											color: #5397F7;
											margin: 0 13px;
        						}
        					}
        					.right {
        						width: 14px;
        						height: 14px;
        						background: url(../../../../../../static/images/study/icon/shanchu_hv.png) no-repeat;
										background-size: cover;
										cursor: pointer;
										&:hover {
											background: url(../../../../../../static/images/study/icon/shanchu.png) no-repeat;
											background-size: cover;
										}
        					}
        				}
        			}
						}
					}
				}
			}
			.note-list-item:last-child {
				margin-bottom: 0;
			}
		}
		.noData {
			height: calc(100% - 40px);
      text-align: center;
      img{
        width: 200px;
        margin-top: 100px;
      }
      p{
        font-size:14px;
        font-weight:400;
        color:rgba(153,153,153,1);
        margin-top: 16px;
      }
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/note/classNote.vue